import React from 'react';
import { safeFormArray } from '../state/state';
import FormTextArea from './FormTextArea';

const FormTextArray = ({
  autoFocus,
  disabled,
  error,
  field,
  text,
  onChange,
}) => (
  <FormTextArea
    autoFocus={autoFocus}
    error={error}
    disabled={disabled}
    onChange={(value) => onChange(value.split(/[\n,;]+/).map((s) => s.trim()))}
    field={field}
    text={safeFormArray(text).join('\n')}
  />
);

export default FormTextArray;
